import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const change = (store, data) => {
  store.setState((state) => {
    state.developer.audits.applogs.data = {
      ...state.developer.audits.applogs.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.developer.audits.applogs.busy = true;
  });

  try {
    params = {
      limit: params.limit || store.state.developer.audits.applogs.pagination.limit,
      ...params,
    };

    const response = await Http.get(`/app/audits/app-logs`, { params });

    store.setState((state) => {
      state.developer.audits.applogs = {
        ...state.developer.audits.applogs,
        busy: false,
        data: response.data,
        pagination: {
          ...state.developer.audits.applogs.pagination,
          ...response.meta.pagination,
          limit: params.limit || state.developer.audits.applogs.pagination.limit,
        },
        filters: {
          ...state.developer.audits.applogs.filters,
          ...params,
          to: params.to,
          from: params.from,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.developer.audits.applogs.busy = false;
      state.developer.audits.applogs.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.developer.audits.applogs = { ...initialState };
  });
};

const AppLogListStore = {
  state: () => initialState,
  actions: {
    change,
    paginate,
    reset,
  },
};

export default AppLogListStore;
